import { Content } from './content.model';

interface IMyContentList {
  content: Content[];
  currentPage: number;
  sizePage: number;
  hasMorePages: boolean;
  firstLoad: boolean;
}

interface IContentType {
  courses: IMyContentList;
  books: IMyContentList;
}

export class ContentStore implements IContentType {
  
  courses = {
    content: [],
    currentPage: 0,
    sizePage: 25,
    hasMorePages: false,
    firstLoad: false
  };

  books = {
    content: [],
    currentPage: 0,
    sizePage: 25,
    hasMorePages: false,
    firstLoad: false
  }

  constructor() {}

}